export type StrapiMedia = {
	url: string;
	provider: string;
};
